<template>
  <vs-col vs-lg="6" vs-xs="12" class="p-1" id="frequency-chart">
    <vs-card :id="headerTitle.replaceAll(' ','')" class="vs-con-loading__container">
      <div :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}" style="display: flex;width: 100%;justify-content: space-between" slot="header">
        <h3>
          {{ headerTitle }}
        </h3>
        <div v-if="showFilter">
          <div v-if="!isRange">
            <date-picker @change="changeFilterMonth" :disabledDate="disableDates" :clearable="false" v-model="month" :type="'month'" valueType="format"></date-picker>
          </div>
          <div v-else>
            <date-picker @change="changeFilterRanged" :range="true" :disabledDate="disableDates" :clearable="false" v-model="monthRange" :type="'month'" valueType="format"></date-picker>
          </div>
        </div>
        <div style="display: flex;margin-top: -4px;margin-bottom: -10px">
          <vs-radio
              :disabled="isLoading || !visitFrequency.chartOptions.series[0].data.length"
              v-model="chartTarget"
              vs-value="booking"
              class="p-1"
          ><div style="margin-left: 5px;margin-right: 5px">{{
              $t("Statistics.VisitFrequency.ParamsPrompt.Booking")
            }}</div></vs-radio
          >
          <vs-radio
              :disabled="isLoading || !visitFrequency.chartOptions.series[0].data.length"
              v-model="chartTarget"
              vs-value="queue"
              class="p-1"
          > <div style="margin-left: 5px;margin-right: 5px">{{ $t("Statistics.VisitFrequency.ParamsPrompt.Queue") }}</div> </vs-radio
          >
        </div>
      </div>
      <div style="min-height: 100px" class="col">
        <div v-if="isLoading" style="display: flex;width: 100%;justify-content: center;height: 100px">
          <div class="spinner-border text-primary" style="margin: auto" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <vue-apex-charts
          v-if="visitFrequency != null && visitFrequency.chartOptions.series[0].data.length"
          height="350"
          ref="visitFrequencyChart"
          :options="visitFrequency.chartOptions"
          :series="visitFrequency.chartOptions.series"
        ></vue-apex-charts>
      </div>
    </vs-card>
  </vs-col>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { statisticsService } from "../../_services";
import DatePicker from "vue2-datepicker";

export default {
  name: "Frequency",
  data: () => ({
    activeVisitPrompt: false,
    month: null,
    monthRange: null,
    visitFrequency: null,
    chartTarget: "queue",
    proceedLoading:true,
    isLoading: false,
  }),
  props: {
    visitFrequencyParams: Object,
    headerTitle: String,
    showFilter: {required: false, type: Boolean},
    isRange: {required: false, type: Boolean},
    dateRange: Array,
    startLoading: Boolean,
    businessList: {required: true, type: Array},
  },
  emits: ['doneLoading'],
  watch: {
    startLoading(newValue) {
      if(newValue) {
        this.isLoading = true;
        this.changeFilterRanged(this.dateRange);
      }
    },
    chartTarget(chartTarget) {
      this.proceedLoading = false;
      this.isLoading = true;
      if(chartTarget === "booking") {
        this.loadBookingsStatistics();
      } else {
        this.loadStatistics();
      }
    }
  },
  methods: {
    loadBookingsStatistics() {
      this.setupChart();
      switch (this.visitFrequencyParams.periodical) {
        case "DAILY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[0]);
          statisticsService
              .bookingVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitBooking.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.xaxis.categories =
                        data.visitBooking.periodical;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "booking";
                    this.visitFrequency.typeData = "booking";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
        case "WEEKLY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .bookingVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    let weeksQueue = data.visitBooking.periodical.map((e, i) =>
                        this.$moment(data.visitBooking.year[i].toString())
                            .add(e, "weeks")
                            .startOf("isoweek")
                            .format("DD/MM/YYYY")
                    );
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitBooking.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.xaxis.categories = weeksQueue;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "booking";
                    this.visitFrequency.typeData = "booking";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
        case "MONTHLY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .bookingVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    let monthesQueue = data.visitBooking.periodical.map(
                        (e, i) =>
                            this.$moment(e, "M").format("MMMM") +
                            " " +
                            data.visitBooking.year[i]
                    );
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitBooking.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.xaxis.categories = monthesQueue;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "booking";
                    this.visitFrequency.typeData = "booking";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
        case "YEARLY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .bookingVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitBooking.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Booking");
                    this.visitFrequency.chartOptions.xaxis.categories =
                        data.visitBooking.periodical;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "booking";
                    this.visitFrequency.typeData = "booking";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
      }
    },
    disableDates(date) {
      const currentMonth = new Date();
      currentMonth.setDate(1);
      return date > currentMonth;
    },
    changeFilterMonth(month) {
      this.month = month;
      this.loadStatistics();
    },
    changeFilterRanged(monthRange) {
      this.monthRange = monthRange;
      this.loadStatistics();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = date.getDate().toString().padStart(2, '0');
      return`${year}-${month}-${day}`;
    },
    getStartDate(month) {
      const [year, monthPart] = month.split('-');
      const startDate = new Date(`${year}-${monthPart}-01 00:00:00`);
      return this.formatDate(startDate);
    },
    getEndDate(month) {
      const [year, monthPart] = month.split('-');
      const lastDay = new Date(year, monthPart, 0);
      const endDate = new Date(`${year}-${monthPart}-${lastDay.getDate()} 23:59:59`);
      return this.formatDate(endDate);
    },
    setupChart() {
      this.visitFrequency = {
        chartOptions: {
          chart: {
            id: "visit-frequency",
            type: "",
            height: 350,
          },
          dataLabels: {
            enabled: false,
          },
          markers: {
            size: 0,
            style: "hollow",
          },
          series: [
            {
              name: "",
              data: [],
            },
          ],
          xaxis: {
            categories: [],
          },
          tooltip: {
            x: {
              format: "dd MMM yyyy",
            },
          },
          title: {
            align: "center",
            margin: 10,
            floating: true,
            style: {
              fontSize: "18px",
              fontWeight: "bold",
              color: "#263238",
            },
          },
        },
        chartData: "",
        chartType: "",
        dateType: "",
        typeData: "",
      };
    },

    loadStatistics() {
      this.setupChart();
      if(this.businessList.length > 0) {
        this.visitFrequencyParams.business_id = this.businessList.map(business => { return business.id; }).toString();
      }
      switch (this.visitFrequencyParams.periodical) {
        case "DAILY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .queueVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitQueue.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.xaxis.categories =
                        data.visitQueue.periodical;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "queue";
                    this.visitFrequency.typeData = "queue";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
        case "WEEKLY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .queueVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    let weeksQueue = data.visitQueue.periodical.map((e, i) =>
                        this.$moment(data.visitQueue.year[i].toString())
                            .add(e, "weeks")
                            .startOf("isoweek")
                            .format("DD/MM/YYYY")
                    );
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitQueue.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.xaxis.categories = weeksQueue;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "queue";
                    this.visitFrequency.typeData = "queue";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
        case "MONTHLY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .queueVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    let monthesQueue = data.visitQueue.periodical.map(
                        (e, i) =>
                            this.$moment(e, "M").format("MMMM") +
                            " " +
                            data.visitQueue.year[i]
                    );
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitQueue.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.xaxis.categories = monthesQueue;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "queue";
                    this.visitFrequency.typeData = "queue";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
        case "YEARLY":
          this.visitFrequencyParams.start = this.getStartDate(this.monthRange[0]);
          this.visitFrequencyParams.end = this.getEndDate(this.monthRange[1]);
          statisticsService
              .queueVisitFrequency(this.visitFrequencyParams)
              .then(
                  function (data) {
                    this.visitFrequency.chartOptions.series[0].data =
                        data.visitQueue.total;
                    this.visitFrequency.chartOptions.series[0].name =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.title.text =
                        this.$t("Statistics.VisitFrequency.Queue");
                    this.visitFrequency.chartOptions.xaxis.categories =
                        data.visitQueue.periodical;
                    this.visitFrequency.chartOptions.chart.type = "area";
                    this.visitFrequency.chartData = "queue";
                    this.visitFrequency.typeData = "queue";
                  }.bind(this)
              )
              .finally(() => {
                this.isLoading = false;
                if(this.proceedLoading) {
                  this.$emit('doneLoading')
                } else {
                  this.proceedLoading = true;
                }
              });
          break;
      }
    },
    visitFrequencyPrompt() {
      this.activeVisitPrompt = true;
      this.reset();
    },
    reset() {
      this.visitFrequency.chartType =
      this.visitFrequency.chartOptions.chart.type;
      this.visitFrequency.dateType = this.visitFrequencyParams.periodical;
      this.visitFrequency.chartData = this.visitFrequency.typeData;
    },
  },
  components: {
    VueApexCharts,
    DatePicker
  },
  mounted() {
    if(this.dateRange == null) {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        this.month = `${year}-${month}`;
        this.monthRange = [`${year}-${(currentDate.getMonth() + -1).toString().padStart(2, '0')}`, this.month]
    }
    this.setupChart();
  },
};
</script>

<style>
</style>